import { Modal, ModalProps } from '@design/components/modal/Modal';
import clsx from 'clsx';

import styles from './ModalLarge.module.scss';

export const ModalLarge = ({ className, children, ...rest }: ModalProps) => (
  <Modal
    data-testid="modal-large"
    {...rest}
    className={clsx(styles.styledModal, className)}
  >
    <div data-testid="modal-large-content" className={styles.content}>
      {children}
    </div>
  </Modal>
);
